import React from 'react'
import SettingComponent from 'components/Settings/SettingComponent'
import './styles.css'

const SettingContainer = (props: any) => {
  return <SettingComponent/>
}

export default SettingContainer